import Spinner from 'react-bootstrap/Spinner';
import xss from "xss";

import CONFIG from "./config";
import { Outlet } from "./utils/components/router";
import { maRoutes } from "./MaRoutes";
import { kundenRoutes } from "./KundenRoutes";
import { contextPath, contextMatchPath, sessionLoader, dataLoader } from "./utils/functions";
import { ErrorPage, PageNotFound } from "./pages";
import Landingpage from './pages/landingpage';

export default (args) => {
  const { state, setState } = args || {};

  const getData = async (RouterMatch, parent) => {
    const error = await dataLoader(RouterMatch, parent);
    if (error) {
      setState({ error: true, errorMsg: xss(error.message) });
    } else {
      setState({ loaded: true });
    }
  };

  const getSession = async (routerMatch, parent) => {
    const error = await sessionLoader(routerMatch, parent);
    if (error) {
      setState({ error: true, errorMsg: xss(error.message) });
    } else {
      setState({ initialized: true });
    }
  };

  const Loading = <div className="bootstrap-iso">
    <Spinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>;

  // Entrypoints
  maRoutes.filter(r =>
    r.path === "/" ||
    r.path === contextPath(CONFIG.ANKAUF) ||
    r.path === contextMatchPath(CONFIG.LINK_EMPFEHLUNG)
  ).forEach(root => {
    root.loader = getData;
    root.pendingElement = Loading;
    root.pendingMs = 10;
    root.pendingMinMs = 1000;
  });
  kundenRoutes.filter(r =>
    r.path === "/" ||
    r.path === contextPath(CONFIG.LINK_HOME_KUNDE) ||
    r.path === contextPath(CONFIG.LINK_KUNDE_LOGIN) ||
    r.path === contextPath(CONFIG.LINK_KUNDE_TAN_AUTH) ||
    r.path === contextMatchPath(CONFIG.LINK_EMPFEHLUNG)
  ).forEach(root => {
    root.loader = getData;
    root.pendingElement = Loading;
    root.pendingMs = 10;
    root.pendingMinMs = 1000;
  });

  return [
    {
      path: "/error",
      element: <PageNotFound >error<Outlet></Outlet></PageNotFound>,
      pendingMs: 10,
      pendingElement: Loading
    },
    {
      path: "/",
      element: <Outlet />,
      errorElement: <ErrorPage />,
      pendingElement: Loading,
      pendingMs: 10,
      pendingMinMs: 1000,
      children: [
        {
          path: CONFIG.SHOP_ROOT,
          pendingMs: 10,
          pendingElement: Loading,
          children: [
            {
              path: "/edelmetallShop/start",
              element: <Landingpage />,
              loader: getSession,
              exact: true
            },
            {
              path: "/edelmetallKunde/start",
              element: <Landingpage />,
              loader: getSession,
              exact: true
            },
            {
              path: "/start",
              element: <Landingpage />,
              loader: getSession,
              exact: true
            },
            ...(["/edelmetall", "/sorten", "/edelmetallShop", "/sortenShop"].map(subpath => ({
              path: subpath,
              element: <Outlet />,
              errorElement: <ErrorPage />,
              pendingElement: Loading,
              pendingMs: 10,
              pendingMinMs: 1000,
              loader: getSession,
              children: maRoutes.filter(r => r.meta === undefined || r.meta.active)
            }))),
            ...(["/edelmetallKunde", "/sortenKunde"].map(subpath => ({
              path: subpath,
              element: <Outlet />,
              errorElement: <ErrorPage />,
              pendingElement: Loading,
              pendingMs: 10,
              pendingMinMs: 1000,
              loader: getSession,
              children: kundenRoutes.filter(r => r.meta === undefined || r.meta.active)
            }))),
            {
              path: "/error",
              element: <ErrorPage state={state} />
            }
          ]
        },
        {
          path: "/*",
          element: <PageNotFound ></PageNotFound>,
          pendingMs: 10,
          pendingElement: Loading,
        }
      ]
    }
  ];
};
